<template>
  <div class="BodyContentCodeBlock">
    <div v-if="value.title" class="title">{{ value.title }}</div>
    <pre class="code">{{ value.code }}</pre>
  </div>
</template>

<script setup>
const { value } = defineProps({ value: Object })
</script>

<style scoped>

.BodyContentCodeBlock {
  margin: var(--spacing-7) 0;
}

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.code {
  background-color: var(--bg-color-pale-gray);
  padding: var(--spacing-7) var(--spacing-10);
  font-size: var(--font-size-2);
  color: var(--text-color-black);
  overflow-y: auto;
}

.title + .code {
  margin-top: var(--spacing-0);
}
</style>
